@if (central || subRegion || region || lastMonthOfContribution) {
  <div class="info-card">
    @if (central) {
      <div class="info-card__item">
        <span class="info-card__label">{{ 'FINANCIAL.central' | translate }}</span>
        <span class="info-card__value">{{ central }}</span>
      </div>
    }
    @if (subRegion || region) {
      <div class="info-card__item">
        <span class="info-card__label">{{ 'FINANCIAL.region' | translate }}</span>
        <span class="info-card__value">{{ subRegion || region }}</span>
      </div>
    }
    @if (lastMonthOfContribution) {
      <div class="info-card__item">
        <span class="info-card__label">{{ 'FINANCIAL.latest_contribution' | translate }}</span>
        <span class="info-card__value">{{ lastMonthOfContribution }}</span>
      </div>
    }
  </div>
} @else {
  <div class="info-card-empty">
    <i class="fa fa-inbox info-card-empty__icon"></i>
    <span>{{ 'GENERAL.no_data' | translate }}</span>
  </div>
}
